import type { GqlTemplate } from "./client-gql/types.ts";

export function mapTemplateItem(item: GqlTemplate): unknown {
    const categories = (item.categoryCollection?.items ?? [])
        .filter(
            (cat): cat is NonNullable<typeof cat> =>
                cat !== null && cat !== undefined
        )
        .map((cat) => ({
            sys: { id: cat.sys.id },
            fields: {
                urlSlug: cat.urlSlug ?? "",
                categoryNameExternal: cat.categoryNameExternal ?? ""
            }
        }));

    const products = (item.productCollection?.items ?? [])
        .filter(
            (prod): prod is NonNullable<typeof prod> =>
                prod !== null && prod !== undefined
        )
        .map((prod) => ({
            sys: { id: prod.sys.id },
            fields: {
                internalTitle: prod.internalTitle ?? "",
                url: prod.url ?? "",
                productNameReference: {
                    fields: {
                        productName:
                            prod.productNameReference?.productName ?? ""
                    }
                }
            }
        }));

    return {
        sys: { id: item.sys.id },
        fields: {
            templateNameInternal: item.templateNameInternal ?? "",
            templateNameExternal: item.templateNameExternal ?? "",
            oneLinerHeadline: item.oneLinerHeadline ?? "",
            fullUrlSlug: item.fullUrlSlug ?? "",
            templateIcon: item.templateIcon
                ? {
                      fields: {
                          file: {
                              url: item.templateIcon.url ?? "",
                              title: item.templateIcon.title ?? ""
                          }
                      }
                  }
                : null,
            templateThumbnail: item.templateThumbnail
                ? {
                      fields: {
                          file: {
                              url: item.templateThumbnail.url ?? "",
                              title: item.templateThumbnail.title ?? ""
                          }
                      }
                  }
                : null,
            category: categories,
            product: products
        }
    };
}
